import { Base } from '../core/base.model';
import { FetchResult } from '../emision/FetchResult.model';
import { Menu } from './menu.model';

export class Perfil extends Base {

    public pId: number;
    public pNombre: string;
    public pSitio: string;
    public pEstatus: number;
    public estatusSlidder: boolean;
    public totalPaginas :Array<number>;
    public itemInicial:number;
    public pNumItems:number;
    public param: string;
    public item: number;
    public pParam: string;
    /* nueva variables agregadas para crypto moneda*/
    public fetch: FetchResult<Perfil> = new FetchResult<Perfil>();

    public nombre: string;
    public sitio: string;
    id: Number;
    menus: Menu [];

    public select: boolean = false;
   // public id: number;
}